<template>
<div>
<DataTable 
:value="items" 
:lazy="lazy" 
:paginator="true" 
class="p-datatable-suppliers" 
:rows="limit"
dataKey="id" 
:page="page+1"
:first="first"
:rowHover="true"  
v-model:filters="filters" 
:reorderableColumns="is_sortable"
@columnReorder="onColReorder"
:totalRecords="totalRecords"
filterDisplay="menu" 
:loading="loading"
@page="onPage($event)" 
@filter="onFilter($event)"
@sort="onSort($event)" 
paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
:rowsPerPageOptions="[5,10,25,50,100]"
currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
:globalFilterFields="globalFilterFields" 
responsiveLayout="scroll"
>
            <template #header>
            	<div class="grid">
            		<div class="col-12 md:col-6">
            			
            		</div>

            		<div class="col-12 md:col-6">
            			<div class="flex justify-content-end align-items-center">
            				<span class="p-input-icon-left">
                                <i class="pi pi-search" />
		                        <InputText v-model="filters['global'].value" placeholder="Arama" class="w-full"/>
		                    </span>
            			</div>
            		</div>

            	</div>
                 
            </template>
            <template #empty>
            <div class="grid">
            <div class="flex justify-content-center  align-items-center mx-6 col"> 
            <h3 class="text-primary"> {{$store.state.languages.lang_phrases.sonuc_bulunamadi}}</h3>
            </div>
            </div>   
            </template>
            <template #loading>
                <div class="loading_overlay">
                    <ProgressSpinner style="width:50px;height:50px" strokeWidth="4" color="deneme" />
                Loading data. Please wait.
            </div>
            </template>
            <Column :rowReorder="true" headerStyle="width: 3rem" :reorderableColumn="false" v-if="is_sortable" />


            <template v-for="columnitem in columns">

<!-- text-->
<template v-if="columnitem.type=='text'">

  <template v-if="columnitem.field=='name'">
   <Column sortable   :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
  <template #body="slotProps">
  <router-link class="text-primary p-link no-underline" :to="{ name: routename , params: { [identifiername]: slotProps.data[identifier] }}">{{getTheTranslation(slotProps.data,"translation")}}</router-link>
  </template>
  </Column>
  </template>





  <template v-else>
    <template v-if="columnitem.with_route">
      <template v-if="columnitem.multilingual">


       <Column sortable   :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
      <template #body="slotProps">
        <template v-for="column_tranlation in slotProps.data[columnitem.field]">
          

           <router-link v-show="column_tranlation.language_id== $store.state.auth.user.preflang_id" class="text-primary p-link no-underline" :to="{ name: routename , params: { [identifiername]: slotProps.data[identifier] }}">{{column_tranlation.translation}}</router-link>

        </template>
      
      </template>
      </Column>

      </template>
      <template v-else-if="columnitem.translated">
        <router-link class="text-primary p-link no-underline" :to="{ name: routename , params: { [identifiername]: slotProps.data[identifier] }}">{{getTheTranslation(slotProps.data,"translation")}}</router-link>
      </template>
      <template v-else>
       <Column sortable   :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
      <template #body="slotProps">
      
      <router-link  class="text-primary p-link no-underline" :to="{ name: routename , params: { [identifiername]: slotProps.data[identifier] }}">{{ slotProps.data[columnitem.field]}}</router-link>
      </template>
      </Column>
        
      </template>
    </template>

    <template v-else>
      <template v-if="columnitem.multilingual">
        
         <Column sortable    :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
          <template #body="slotProps">

            <template v-for="column_tranlation in slotProps.data[columnitem.field]">
              <p  v-show="column_tranlation.language_id== $store.state.auth.user.preflang_id">{{ column_tranlation.translation}}</p>
            </template>
            
          </template>
        </Column>
      </template>
      <template v-else-if="columnitem.translated">

         <p  >{{getTheTranslation(slotProps.data,"translation")}}</p>
      </template>
      <template v-else>
        <template v-if="columnitem.is_meta"> 
             <Column sortable   :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
            <template #body="slotProps">
            <p>{{ slotProps.data.meta[columnitem.field]}}</p>
            </template>
            </Column>
        </template>
        <template v-else>
            <Column sortable   :field="columnitem.field" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}"></Column>
        </template>
         
      </template>
       
    </template>  

  </template>






</template>
<!-- text-->

 <Column sortable   v-if="columnitem.type=='date'" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">
<p>{{ $filters.momentFormat( slotProps.data[columnitem.field]," Do-MM-YYYY HH:mm")}}</p>
</template>
</Column>

 <Column sortable   v-if="columnitem.type=='daterelation'" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">
<p>{{ $filters.momentFormat( slotProps.data[columnitem.field][columnitem.relation_field]," Do-MM-YYYY")}}</p>
</template>
</Column>


 <Column sortable   v-if="columnitem.type=='boolean'" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">
<p v-html="$filters.booleanView( slotProps.data[columnitem.field])"></p>
</template>
</Column>

 <Column sortable   v-if="columnitem.type=='count'" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">
<p>{{ slotProps.data[columnitem.field].length}}</p>
</template>
</Column>



<template v-if="columnitem.type=='relation'">
<template v-if="columnitem.with_route">
 <Column sortable   :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">


<router-link  class="text-primary p-link no-underline" :to="{ name: routename , params: {id:slotProps.data[identifier]}}">{{ slotProps.data[columnitem.field][columnitem.relation_field]}}</router-link>
</template>
</Column>

</template>
<template v-else>
 <Column sortable   :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">
<p>{{ slotProps.data[columnitem.field][columnitem.relation_field]}}</p>
</template>
</Column>
</template>

</template>







<Column v-if="columnitem.type=='pill'" :field="columnitem.field"  :header="$store.state.languages.lang_phrases[columnitem.header]" :filterMenuStyle="{'width':'14rem'}" style="min-width:12rem">
<template #body="{data}">

<Tag 
class="mr-2 mt-1 custom-chip" 
v-for=" element in columnitem.options"  
v-show="element.name==data[columnitem.field]"
:value="$store.state.languages.lang_phrases[element.text]" 
:style="'background-color:'+element.color"
/>

</template>
<template #filter="{filterModel}">
    <Dropdown v-model="filterModel.value" :options="columnitem.selectors" placeholder="Hepsi" class="p-column-filter" :showClear="true" @change="testvalue($event,filterModel)">
        <template #value="slotProps">
            <span v-if="slotProps.value">{{slotProps.value}}</span>
            <span v-else>{{slotProps.placeholder}}</span>
        </template>
        <template #option="slotProps">
            <span>{{slotProps.option}}</span>
        </template>
    </Dropdown>
</template>
</Column>




















 <Column sortable   v-if="columnitem.type=='color'" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">

<!--<p>{{ slotProps.data[columnitem.field][columnitem.relation_field]}}</p>-->
<Tag 
class="mr-2 mt-1 custom-chip"  
v-if="slotProps.data[columnitem.field]"
:style="'background-color:'+slotProps.data[columnitem.field]"

/>
</template>
</Column>




<template v-if="columnitem.type=='deeprelation'">
<template v-if="columnitem.with_route">
 <Column sortable   :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">

<router-link  class="text-primary p-link no-underline" :to="{ name: routename , params: {id:slotProps.data[identifier]}}">{{ slotProps.data[columnitem.field][columnitem.deepfield][columnitem.relation_field]}}</router-link>
</template>
</Column>

</template>
<template v-else>
 <Column sortable   :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">
<p>{{ slotProps.data[columnitem.field][columnitem.deepfield][columnitem.relation_field]}}</p>
</template>
</Column>
</template>

</template>

 <Column sortable   v-if="columnitem.type=='relationarray'" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}" style="max-width: 8rem">
<template #body="slotProps">
<Tag  v-for="(element,index) in  slotProps.data[columnitem.field]" :key="element.id" :value="element[columnitem.relation_field]" class="mr-2 " style="text-transform: capitalize"/>
</template>
</Column>



</template>


          
<!--
<Column   headerStyle="width: 4rem; text-align: center" bodyStyle="text-align: center; overflow: visible" class="">
<template #body="slotProps">
<Button type="button"  icon="pi pi-ellipsis-h" @click="toggle($event,slotProps.data.id)" aria-haspopup="true" :aria-controls="'overlay_menu'+slotProps.data.id" class="p-button-primary p-button-text p-button-sm mt-1"   />
<Menu :id="'overlay_menu'+slotProps.data.id" :ref="'menu'+slotProps.data.id" :model="menuitems" :popup="true">
<template #item="{item}">  
<template v-if="item.label=='Sil'">
<template v-if="deleteobjectname">
<a class="p-menuitem-link" 
role="menuitem" 
@click="item.command(item.argument,{[identifiername]:slotProps.data[identifier]})"
>
<span :class="'p-menuitem-icon '+item.icon"></span>
<span class="p-menuitem-text">{{item.label}}</span>
<span class="p-ink"></span></a>
</template>
</template>
<template v-else>
<a class="p-menuitem-link" 
role="menuitem" 
@click="item.command(item.argument,{[identifiername]:slotProps.data[identifier]})"
>
<span :class="'p-menuitem-icon '+item.icon"></span>
<span class="p-menuitem-text">{{item.label}}</span>
<span class="p-ink"></span></a>
</template>

</template>
</Menu>
</template>
</Column>
-->
            

            
            

 <Column headerStyle="width: 4rem; text-align: center" bodyStyle="text-align: center; overflow: visible" class="">
<template #body="slotProps">
 <Button type="button"  icon="pi pi-ellipsis-h" @click="toggle($event,slotProps.data.id)" aria-haspopup="true" :aria-controls="'overlay_menu'+slotProps.data.id" class="p-button-primary p-button-text p-button-sm mt-1"   />
<Menu :id="'overlay_menu'+slotProps.data.id" :ref="'menu'+slotProps.data.id" :model="menuitems" :popup="true">
 <template #item="{item}">  
  
  <a class="p-menuitem-link" 
  role="menuitem" 
  @click="item.command(slotProps.data.id)"
  >
  <span :class="'p-menuitem-icon '+item.icon"></span>
  <span class="p-menuitem-text">{{item.label}}</span>
  <span class="p-ink"></span></a>

</template>
</Menu>
</template>
</Column>     

            

            


        	
           
            
            
            
            
            


        </DataTable>
</div>
</template>

<script>
import {FilterMatchMode,FilterOperator} from 'primevue/api';
import TableTag from "./TableTag"


export default {

  name: '"SortableTableExtended"',
  components:{TableTag},
  props:["columns","routename","deleteobjectname","identifier_row","identifier_row_name","sortable","pageble","getroute",],
  data () {
    return {
    	loading: false,  
        items:[], 
        page:0,
        limit:10,   
        first:0, 
        totalRecords:0, 
        sort_column:"created_at",
        sort_order:"asc",
        filters: {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'name': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
        'date': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]},
        'status': {value: null, matchMode: FilterMatchMode.EQUALS},
        'nonconformityclosure_status': {value: null, matchMode: FilterMatchMode.EQUALS},
        },
    	menuitems: [
    		{
                label: this.$store.state.languages.lang_phrases.goruntule,
                icon: 'pi pi-eye',
                command: (id) => {
                console.log("git")
                console.log(id)
                console.log(this.routename)
                this.gotoPage(this.routename,{[this.identifiername]:id})
                }
            },
            {
                label: this.$store.state.languages.lang_phrases.sil,
                icon: 'pi pi-trash',
                command: (id) => {
                console.log("sil")
                console.log(id)
                //return false
                this.deleteItem(this.deleteobjectname,id)
                }
            },

    	]
    }
  },
  computed:{
    lazy()
    {   
        if(this.pageble)
        {
            return true
        }
        return false
    },
    globalFilterFields()
    {
        let items = this.columns.map((item)=>{return item.field})
        return items

    },
    deletedstate()
    {
        return this.$store.state.ui.deletedstate
    },
    identifier()
    {
      if(this.identifier_row)
      {
        return this.identifier_row
      }
      else
      {
        return "id"
      }
    },
    identifiername()
    {
      if(this.identifier_row_name)
      {
        return this.identifier_row_name
      }
      else
      {
        return "id"
      }
    },
    is_sortable()
    {
      if(this.sortable)
      {
        return true
      }
      else
      {
        return false
      }
    },
    is_pageble()
    {
      if(this.pageble)
      {
        return true
      }
      else
      {
        return false
      }
    }
  },
  watch:{
    deletedstate(newVal,oldVal)
    {
        if(newVal)
        {
            this.$emit("dataDeleted")
        }
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    async getData()
    {
        //this.data = await this.generalApiGet("tickets/admin_all_tickets") 
    this.loading = await true
      if(this.is_pageble)
      {
        console.log("pageble")
        let data = await this.generalApiGetWithoutLoader(this.getroute+"/"+this.page+"/"+this.limit+"?sort_column="+this.sort_column+"&sort_order="+this.sort_order)
        
        this.items = await data.data
        this.totalRecords = await data.meta.total                
      }
      else
      {
        this.items = await this.generalApiGetWithoutLoader(this.getroute)
        this.totalRecords = this.items.length
      }
      

      //this.$router.replace({ name: "user-view", params: {id:"123"}, query: {q1: "q1"} })
      this.loading = await false
      console.log(this.items)
      
      
    },
    onColReorder(event)
    {
        console.log(event)
    },

    onPage(event)
    {
        this.page = event.page
        this.getData()
        console.log(event)        
    },

    onFilter(event)
    {
        console.log("filter")
        //this.$emit("filter",event)
    },
    onSort(event)
    {
        console.log(event)
        this.sort_column = event.sortField
        if(event.sortOrder===1)
        {
            this.sort_order = "asc"
        }
        else
        {
            this.sort_order = "desc"
        }
        this.getData()

    },
    testvalue(event,filterModel)
    {
        console.log(event)
        console.log(filterModel)
    },
   

  	toggle(event,id) {
        this.$refs['menu'+id].toggle(event);
    },
    gotoSupplier(id)
    {
        this.$router.push({ name: "Supplier", params:{ id:id} }) 
    }
  }
}
</script>

<style lang="scss" scoped>
.loading_overlay
{
    background-color:rgba(53, 47, 141, 0.5);
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    color:#fff;
    flex-direction:column;

}
::v-deep(.p-paginator) {
    .p-paginator-current {
        margin-left: auto;
    }
}

::v-deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #607D8B;
    }
}

::v-deep(.p-datepicker) {
    min-width: 25rem;

    td {
        font-weight: 400;
    }
}

::v-deep(.p-datatable.p-datatable-suppliers) {
    .p-datatable-header {
        padding: 1rem;
        text-align: left;
        font-size: 1.5rem;
    }

    .p-paginator {
        padding: 1rem;
    }

    .p-datatable-thead > tr > th {
        text-align: left;
    }

    .p-datatable-tbody > tr > td {
        cursor: auto;
    }

    .p-dropdown-label:not(.p-placeholder) {
        text-transform: uppercase;
    }
}
</style>,